import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title = "DEBECO - Débarras & Recyclage",
  description = "Service professionnel de débarras en Savoie, Haute-Savoie et Ain. Vide-maison, appartement, cave, grenier, succession.",
  canonical,
  noindex = false,
  ogImage = "/images/annecy.jpg",
  ogType = "website",
  jsonLd
}) => {
  const location = useLocation();
  const siteUrl = "https://debeco.fr";
  const path = canonical || location.pathname;
  const canonicalUrl = `${siteUrl}${path}`;
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;
  const robotsContent = noindex 
    ? "noindex, nofollow" 
    : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1";

  useEffect(() => {
    document.title = title;

    const setMeta = (attr, attrValue, content) => {
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    setMeta('name', 'robots', robotsContent);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:type', ogType);
    setMeta('property', 'og:image', fullOgImage);
    setMeta('property', 'og:site_name', 'DEBECO');
    setMeta('property', 'og:locale', 'fr_FR');
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);

    return () => {
      const can = document.querySelector('link[rel="canonical"]');
      if (can) can.remove();
    };
  }, [title, description, canonicalUrl, fullOgImage, robotsContent, ogType]);

  useEffect(() => {
    if (!jsonLd) return;
    const schemas = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    const scripts = schemas.map(data => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-managed', 'true');
      script.textContent = JSON.stringify(data);
      document.head.appendChild(script);
      return script;
    });
    return () => scripts.forEach(s => s.remove());
  }, [jsonLd]);

  return null;
};

export default SEO;
